var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5693 15.5693C15.2822 15.8564 14.9359 16 14.5303 16C14.1247 16 13.7806 15.8587 13.498 15.5762L10.3125 12.3906C9.96615 12.0443 9.82943 11.6296 9.90234 11.1465L7.31836 8.5625C6.62565 9.11849 5.8737 9.55599 5.0625 9.875C3.72266 9.18229 2.70182 8.16146 2 6.8125C2.4375 5.71875 3.0778 4.7526 3.9209 3.91406C4.764 3.07552 5.73242 2.4375 6.82617 2C8.16602 2.70182 9.18685 3.72266 9.88867 5.0625C9.56055 5.88281 9.11849 6.63477 8.5625 7.31836L11.1465 9.90234C11.6296 9.82943 12.0443 9.96615 12.3906 10.3125L15.5762 13.498C15.8587 13.7806 16 14.1247 16 14.5303C16 14.9359 15.8564 15.2822 15.5693 15.5693Z",
    fill: "#002979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIcon);
export default __webpack_public_path__ + "static/media/bid-icon.581b5cfe593247d4d92f11fb827f3525.svg";
export { ForwardRef as ReactComponent };